
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const PrivateRoute = ({ children }) => {
  const [authReady, setAuthReady] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      const jwt = Cookies.get("jwtToken");
      const isValid = !!user && !!jwt;
      console.log("[PrivateRoute] Auth check → valid:", isValid);
      setIsLoggedIn(isValid);
      setAuthReady(true);
    });

    return () => unsub();
  }, []);

  const isOnLoginPage = location.pathname.startsWith("/login");

  if (!authReady) {
    return (
      <div style={{ padding: 60, textAlign: "center" }}>
        🔐 Checking access...
      </div>
    );
  }

  if (!isLoggedIn && !isOnLoginPage) {
    const redirectPath = `${location.pathname}${location.search}`;
    console.log(
      "[PrivateRoute] Not logged in → redirecting to login:",
      redirectPath
    );
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirectPath)}`}
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
